import { useEffect, useState } from 'react';

/**
 * Returnerer true når viewporten er på eller under `breakpoint`. Brukes av
 * AppLayout til å droppe header-elementer (undertittel, titleAction, søk) på
 * smale skjermer — origo-ui `AppHeader` har CSS Modules-hashede klasser, så
 * elementene kan ikke skjules med app-lokal CSS.
 */
export function useIsNarrow(breakpoint: number): boolean {
    const query = `(max-width: ${breakpoint}px)`;
    const [isNarrow, setIsNarrow] = useState(() =>
        typeof window === 'undefined' ? false : window.matchMedia(query).matches,
    );

    useEffect(() => {
        const mql = window.matchMedia(query);
        setIsNarrow(mql.matches);
        const handler = (e: MediaQueryListEvent) => setIsNarrow(e.matches);
        mql.addEventListener('change', handler);
        return () => mql.removeEventListener('change', handler);
    }, [query]);

    return isNarrow;
}
